import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import AnimatedPage from "../components/AnimatedPage";
import axios from "axios";
import swal from "sweetalert";

function Login() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    // State loading và ghi nhớ mật khẩu
    const [isLoading, setIsLoading] = useState(false);
    const [remember, setRemember] = useState(true); // Đặt mặc định là true giống ảnh có dấu tích sẵn

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        if (login) {
            navigate("/");
        }
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        }).catch(()=>{});

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify !== res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        }).catch(()=>{});
    }, []);

    const onSubmit = async (data) => {
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập tối thiểu 6 kí tự"
            });
            return false;
        }
        if (!regex.test(data.username)) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt"
            });
            return false;
        }
        if (data.password.length < 6) {
            setError("password", {
                type: "minLength",
                message: "Mật khẩu tối thiểu 6 kí tự"
            });
            return false;
        }

        setIsLoading(true);
        setErr(null);

        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                username: data.username.toLowerCase(),
                password: data.password
            })
            .then((res) => {
                setIsLoading(false);
                swal({
                    title: "Thông báo",
                    text: "Đăng nhập thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("profile");
                    localStorage.removeItem("data");
                    localStorage.setItem("user", res.data.data);
                    if (remember) {
                        localStorage.setItem("password", data.password);
                    }
                    navigate("/?notify");
                });
            })
            .catch((error) => {
                setIsLoading(false);
                setErr(error.response?.data?.message ? error.response.data.message : "Tên đăng nhập hoặc mật khẩu không chính xác!");
            });
    };

    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh", background: "#6cd1b0", position: "relative" }}>
            
            <style dangerouslySetInnerHTML={{__html: `
                * { box-sizing: border-box; font-family: 'Roboto', sans-serif; }
                body { margin: 0; padding: 0; background: #6cd1b0; }
                
                .l-container {
                    max-width: 500px; margin: 0 auto; width: 100%; 
                    display: flex; flex-direction: column; position: relative; padding: 15px 20px 40px;
                }

                /* Nút Đóng (X) */
                .l-close-btn { position: absolute; top: 15px; right: 20px; color: #b7e8d6; font-size: 28px; cursor: pointer; z-index: 10; font-weight: 300; }

                /* Logo */
                .l-logo-wrap { display: flex; justify-content: center; margin-top: 30px; margin-bottom: 40px; }
                .l-logo-wrap img { height: 75px; object-fit: contain; }

                /* Form & Inputs */
                .l-form { display: flex; flex-direction: column; gap: 15px; }
                
                .l-input-wrapper { position: relative; display: flex; align-items: center; }
                .l-input-box {
                    width: 100%; border: none; border-radius: 8px; padding: 14px 15px;
                    background: #fff; font-size: 14px; color: #333; outline: none;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.05);
                }
                .l-input-box::placeholder { color: #5a7d6e; }

                .l-eye { position: absolute; right: 15px; color: #5a7d6e; cursor: pointer; display: flex; align-items: center; }

                .l-error-text { color: #d32f2f; font-size: 12px; margin-top: -10px; margin-left: 5px; font-weight: 500; }
                
                /* Hàng Lưu mật khẩu và Quên mật khẩu */
                .l-action-row { display: flex; justify-content: space-between; align-items: center; margin-top: 5px; margin-bottom: 10px; }
                
                .l-remember { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #397a63; cursor: pointer; }
                .l-checkbox-custom {
                    width: 16px; height: 16px; border-radius: 3px; border: 1.5px solid #20a072;
                    display: flex; align-items: center; justify-content: center; transition: 0.2s; background: transparent;
                }
                .l-checkbox-custom.checked { background: #20a072; border-color: #20a072; }
                
                .l-forgot { color: #ffca28; text-decoration: none; font-size: 14px; font-weight: 500; }

                /* Nút Đăng nhập */
                .l-submit-btn {
                    width: 100%; background: linear-gradient(180deg, #ffe066 0%, #ffb300 100%);
                    color: #00695c; font-weight: bold; font-size: 16px; padding: 14px 0;
                    border: 1px solid #f57f17; border-radius: 8px; cursor: pointer; 
                    box-shadow: 0 3px 6px rgba(0,0,0,0.1); margin-top: 5px; transition: 0.2s;
                }
                .l-submit-btn:disabled { opacity: 0.7; cursor: not-allowed; }

                /* Text Đăng ký */
                .l-register-link { text-align: center; font-size: 14px; color: #397a63; margin-top: 20px; }
                .l-register-link a { color: #ffb300; text-decoration: none; font-weight: bold; margin-left: 5px;}
            `}} />

            <div className="l-container">
                <AnimatedPage>
                    
                    {/* NÚT ĐÓNG */}
                    <div className="l-close-btn" onClick={() => navigate("/")}>✕</div>

                    {/* LOGO */}
                    <div className="l-logo-wrap">
                        <img alt="Logo" src="/images/logo.png" />
                    </div>

                    {/* FORM */}
                    <form className="l-form" onSubmit={handleSubmit(onSubmit)}>
                        
                        {/* Tên người dùng */}
                        <div className="l-input-wrapper">
                            <input 
                                type="text" 
                                className="l-input-box" 
                                placeholder="Tên người dùng" 
                                autoComplete="off"
                                {...register("username", { required: true })} 
                            />
                        </div>
                        {errors.username && <div className="l-error-text">{errors.username.message}</div>}

                        {/* Mật khẩu */}
                        <div className="l-input-wrapper">
                            <input 
                                type={showPassword ? "text" : "password"} 
                                className="l-input-box" 
                                placeholder="Mật khẩu" 
                                autoComplete="new-password"
                                {...register("password", { required: true })} 
                            />
                            <div className="l-eye" onClick={toggleShowPassword}>
                                {showPassword ? (
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/></svg>
                                )}
                            </div>
                        </div>
                        {errors.password && <div className="l-error-text">{errors.password.message}</div>}
                        
                        {/* Lỗi API trả về */}
                        {err && <div className="l-error-text" style={{marginTop: '0px'}}>{err}</div>}

                        {/* Hàng "Lưu" & "Quên mật khẩu" */}
                        <div className="l-action-row">
                            <div className="l-remember" onClick={() => setRemember(!remember)}>
                                <div className={`l-checkbox-custom ${remember ? 'checked' : ''}`}>
                                    {remember && <svg viewBox="0 0 24 24" width="12" height="12" fill="#fff"><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>}
                                </div>
                                Lưu
                            </div>
                            <Link to="/service" className="l-forgot">Quên mật khẩu?</Link>
                        </div>

                        {/* Nút Đăng nhập */}
                        <button type="submit" className="l-submit-btn" disabled={isLoading}>
                            {isLoading ? "ĐANG XỬ LÝ..." : "Đăng Nhập"}
                        </button>

                        {/* Text Đăng ký */}
                        <div className="l-register-link">
                            Bạn chưa có tài khoản? <Link to="/register">Đăng ký</Link>
                        </div>

                    </form>

                </AnimatedPage>
            </div>
        </div>
    );
}
export default Login;